import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from "rxjs/operators";
import { pagos360 } from "../models/pagos360"

@Injectable({
  providedIn: 'root'
})
export class Pagos360Service {

  constructor(private http: HttpClient) { }

  pagos360(data: pagos360): Observable<Response> {
    debugger;
    return this.http
      .post(`${environment.urlPagos360}/CrearSolicitudDePago?jurId=${environment.codigoJur}`, data)
      .pipe(map((response: any) => response));
  }
}
